import React from "react";
import { useTheme } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import {
    CircularProgressbarWithChildren,
    buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import ReactLoading from 'react-loading';

const SmallDataMeter = (props) => {
    const theme = useTheme();
    return (
        <React.Fragment>
            <div style={{ width: '88px', height: '88px' }}>
                <CircularProgressbarWithChildren
                    value={100}
                    strokeWidth={4}
                    styles={buildStyles({
                        pathColor: props.inverse ? theme.palette.common.white : theme.palette.primary.main,
                        trailColor: "#eee",
                        pathTransitionDuration: 0,
                    })}
                >
                    {/* Foreground path */}
                    {props && props.Pot ? <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                        style={{ color: props.inverse ? theme.palette.common.white : theme.palette.text.primary }}
                    >
                        {props.Pot.label1 && <div style={{ fontSize: '9px', height: '14px', fontFamily: theme.typography.fontFamily2, fontWeight: 300, fontStyle: 'normal' }} ><span dangerouslySetInnerHTML={{ __html: props.Pot.label1 }} /></div>}
                        {props.Pot.value1 && <div style={{ fontSize: '15px', height: '15px', fontWeight: 500 }}>{props.Pot.value1}</div>}
                        {props.Pot.label2 && <div style={{ fontSize: '8px', height: '12px', fontFamily: theme.typography.fontFamily2, fontWeight: 300, fontStyle: 'normal' }}>{props.Pot.label2}</div>}
                        {props.Pot.value2 && <div style={{ fontSize: '11px', height: '14px', fontWeight: 500 }}>{props.Pot.value2}</div>}

                    </Grid>
                        :
                        <div style={{ marginTop: '-30px' }}>
                            <ReactLoading type="spinningBubbles" color={props.inverse ? theme.palette.common.white : theme.palette.primary.main} height={32} widht={32} />
                        </div>
                    }
                </CircularProgressbarWithChildren>
            </div>
        </React.Fragment>
    );
}

export default SmallDataMeter;